export const getActionLabel = (actionLabel = "", edit = false) => {
  const normalizedLabel = `${actionLabel}`.trim().toLowerCase()
  if (normalizedLabel) return normalizedLabel
  return edit ? "save" : "submit"
}
